/// <amd-module name="Feed/Legacy/Protocols/NuGet/NuGetPackageDetails" />
/* tslint:disable:no-require-imports */
import * as VSS_Common_Contracts from "VSS/Platform/Contracts/WebApi";

import * as Contracts from "Feed/Common/Protocols/NuGet/Contracts/NuGet";

import JsonPatchOperation = VSS_Common_Contracts.JsonPatchOperation;
export class PackageVersionDetails implements Contracts.PackageVersionDetails {
    public readonly listed: boolean;
    public readonly views: JsonPatchOperation;
    constructor(listed?: boolean, viewToAdd?: string) {
        this.listed = listed;
        const patchDocument: VSS_Common_Contracts.JsonPatchOperation = {
            from: null,
            op: VSS_Common_Contracts.Operation.Add,
            path: "/views/-",
            value: viewToAdd
        };
        this.views = patchDocument;
    }
}
